import { MessagesMockApi } from 'app/mock-api/common/messages/api';
import { NotificationsMockApi } from 'app/mock-api/common/notifications/api';
import { ShortcutsMockApi } from 'app/mock-api/common/shortcuts/api';

export const mockApiServices = [
    MessagesMockApi,
    NotificationsMockApi,
    ShortcutsMockApi,
];
